import api from './api';

export const visitorService = {
    // Track kunjungan
    trackVisit: async (pageUrl = '/') => {
        try {
            const response = await api.post('/visitor/track', { page_url: pageUrl });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal track kunjungan' };
        }
    },

    // Get statistik
    getStatistics: async () => {
        try {
            const response = await api.get('/visitor/statistics');
            return { success: true, data: response.data.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat statistik' };
        }
    },

    // Get chart data
    getChart: async (period = '7days') => {
        try {
            const response = await api.get('/visitor/chart', { params: { period } });
            return { success: true, data: response.data.data };
        } catch (error) {
            return { success: false, message: 'Gagal memuat chart' };
        }
    },
};

export default visitorService;